<mat-form-field appearance="outline" style="width: 600px;">
    <textarea matInput rows="5" cols="40"></textarea>
</mat-form-field>
